import { ApiRequestStore } from '../../../common/apiRequest.store'

class DeleteSceneStore extends ApiRequestStore {}

export const deleteSceneStore: DeleteSceneStore = new DeleteSceneStore()
